export default __webpack_public_path__ + "static/media/Delhi.b588fc98.png";